export var IdInventoryResourceRequirementPosition;
(function (IdInventoryResourceRequirementPosition) {
    IdInventoryResourceRequirementPosition[IdInventoryResourceRequirementPosition["Vertical"] = 0] = "Vertical";
    IdInventoryResourceRequirementPosition[IdInventoryResourceRequirementPosition["Horizontal"] = 1] = "Horizontal";
})(IdInventoryResourceRequirementPosition || (IdInventoryResourceRequirementPosition = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/inventory-resource-requirement/IdInventoryResourceRequirementPosition.ts
// module id = 604
// module chunks = 3